import React, { useCallback, useEffect } from 'react';

import BarcodeReadRegularIcon from '../../../../shared/icons/barcode-read-regular-icon';
import Button from '../../../button/button';

import { useMediaQuery, useModal } from '../../../../shared/hooks/hooks';

import { loadScript, removeScript } from '../../../../shared/utils/page/page';

import { TIRE_SCANNER } from '../../../../shared/constants/modals';

import './fitment-sub-tabs.scss';

export interface Tab {
  ariaControls: string;
  description: string;
}

interface FitmentSubTabsProps {
  className?: string;
  hideTabs?: boolean;
  onTabSelect?: (tab: Tab) => void;
  onTireScanned?: (tireWidth, selectedTireCrossDimension, tireDiameter) => void;
  selectedTab?: Tab;
  showScanner?: boolean;
  tabs: Tab[];
}

function FitmentSubTabs(props: FitmentSubTabsProps) {
  const {
    className = '',
    hideTabs = false,
    onTabSelect,
    onTireScanned: onTireScannedProp,
    selectedTab,
    showScanner = false,
    tabs
  } = props;
  const { closeModal, openModal } = useModal();
  const { isMinLg } = useMediaQuery();
  const SCANNER_ID = 'tire-scanner';

  const onTireScanned = useCallback(
    result => {
      const defaultValue = { text: '0' };
      const {
        diameter = defaultValue,
        ratio = defaultValue,
        width = defaultValue
      } = result || {};
      onTireScannedProp?.(width.text, ratio.text, diameter.text);
      closeModal();
    },
    [closeModal, onTireScannedProp]
  );

  useEffect(() => () => removeScript(SCANNER_ID), []);

  return (
    <div
      className={`fitment-sub-tabs ${className}`}
      role="tablist"
      styleName="container"
    >
      {!hideTabs && (
        <div styleName="button-container">
          {Array.isArray(tabs) &&
            tabs.map((tab, idx) => (
              <Button
                aria-controls={tab.ariaControls}
                aria-selected={selectedTab === tab}
                id={`tab-${tab.description.toLowerCase()}`}
                key={idx}
                onClick={() => {
                  if (selectedTab !== tab) {
                    onTabSelect?.(tab);
                  }
                }}
                role="tab"
                size="regular"
                styleName={selectedTab === tab ? 'tab-selected' : 'tab'}
              >
                {tab.description.toLowerCase()}
              </Button>
            ))}
        </div>
      )}
      {process.env.__ANYLINE_OCR_KEY__ && !isMinLg && showScanner && (
        <Button
          isSecondary
          onClick={() => {
            if (window.anylinejs) {
              openModal(TIRE_SCANNER, {
                onTireScanned
              });
            } else {
              loadScript(
                {
                  id: SCANNER_ID,
                  onload: () =>
                    openModal(TIRE_SCANNER, {
                      onTireScanned
                    }),
                  src: 'https://js.anyline.com/release/42.5.0/anyline.js'
                },
                false
              );
            }
          }}
          styleName="scan-button"
        >
          <BarcodeReadRegularIcon styleName="barcode-icon" />
          Scan Tire Sidewall
        </Button>
      )}
    </div>
  );
}

export default FitmentSubTabs;
